export const LOGO_URL =
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_177b7daa-eba9-4d6c-9a57-626f386a4357/artifacts/a79dc1c945bcacb8_BB%20Logo%202026.png";

export const OWNER_EMAIL = "brainbrushb2b@gmail.com";

export const IMAGES = {
    hero: "https://customer-assets-rejwkqb3.emergentagent.net/job_neural-brush-design--8h5r9xph/artifacts/5fa60a8d38b43178_illus.png",
    about: "https://images.unsplash.com/photo-1622547748225-3fc4abd2cca0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    services: "https://images.unsplash.com/photo-1618005198919-d3d4b5a92ead?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
};

export const CLIENTS = [
    "WoW Wear",
    "Vanakkam",
    "RGB Invest",
    "Urthh",
    "Obaa",
    "Find Nearby Places",
    "Torayy",
    "Mining",
    "TO · Track Order",
];

export const NAV_LINKS = [
    { label: "About", id: "about" },
    { label: "Services", id: "services" },
    { label: "Process", id: "process" },
    { label: "Why Us", id: "why-us" },
    { label: "Contact", id: "contact" },
];
